import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { motion } from 'framer-motion';
export const Hero: React.FC = () => {
  return <div className="w-full relative overflow-hidden min-h-[60vh] flex items-center pt-32 pb-20" data-id="element-403">
      {/* Background image */}
      <img src="https://cdn.magicpatterns.com/uploads/joW23QukC9PHBnWHCKRxNE/Container_(2).png" alt="Team Norden Digital" className="absolute inset-0 w-full h-full object-cover" data-id="element-404" />
      {/* Subtle dark overlay for text readability */}
      {/* Blue glow overlay matching brand color */}
      <div className="absolute inset-0 bg-gradient-to-br from-[#004AC7]/55 via-[#003A9E]/45 to-black/50 mix-blend-multiply" data-id="element-405"></div>
      <div className="absolute inset-0 bg-[#004AC7]/20" data-id="element-406"></div>

      <div className="container mx-auto px-4 md:px-6 lg:px-8 max-w-[1200px] relative z-10" data-id="element-407">
        <div className="max-w-4xl mx-auto text-center" data-id="element-408">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} data-id="element-409">
            <h1 className="font-bold text-white leading-tight mb-6 text-4xl md:text-5xl lg:text-6xl drop-shadow-lg" data-id="element-410">
              Klanten buiten je netwerk? Dat begint met bewijs.
            </h1>

            <p className="text-gray-100 mb-10 text-lg md:text-xl leading-relaxed max-w-3xl mx-auto drop-shadow-md" data-id="element-411">
              Stel: je wilt vis vangen. Je hebt een net (je website) en aas
              (marketing). Maar weet je wáár je het net laat zakken? Of doe je
              dat op gevoel? Wij bouwen geen website op aannames. We gooien
              eerst aas uit, kijken waar de vis toehapt met harde data, en
              bouwen pas dán je net op die plek.
            </p>

            <div className="flex justify-center" data-id="element-412">
              <a href="#contact" className="inline-flex items-center justify-center bg-[#004AC7] hover:bg-[#003A9E] text-white font-bold py-4 px-8 rounded-lg transition duration-300 shadow-lg group" data-id="element-413">
                Plan een kennismaking
                <ArrowRightIcon className="h-5 w-5 ml-2 transform group-hover:translate-x-1 transition-transform" data-id="element-414" />
              </a>
            </div>
          </motion.div>
        </div>
      </div>
    </div>;
};